// extracted by mini-css-extract-plugin
module.exports = {"project-detail":"styles_project-detail__UJrAA","projectDetail":"styles_project-detail__UJrAA"};